import { MonitorDeliveriesMain } from '@/_features/monitor-deliveries';

function MonitorDeliveries() {
  return (
    <div className="container">
      <MonitorDeliveriesMain />
    </div>
  );
}

export default MonitorDeliveries;
